import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import './styles.css';

const CommentIconButton = props => {
  const { count, onClick } = props;
  return (
    <div className="comment-icon-button">
      <span
        className="comment-icon-button__icon"
        onClick={onClick ? onClick : null}
      />
      <span
        className="comment-icon-button__counter"
        onClick={onClick ? onClick : null}
      >
        (<NumberFormat thousandSeparator value={count} displayType={'text'} />)
      </span>
    </div>
  );
};

CommentIconButton.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClick: PropTypes.func,
};

export default CommentIconButton;
